import React from 'react'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import { media } from 'styled-bootstrap-grid'

const SectionStyled = styled.section`
  margin-bottom: 32px;
  border-bottom: 1px solid #eee;
  text-align: justify;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 8px rgba(0,0,0,.05);
  p {
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
  ul {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    li {
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  ${media.md`
    padding: 32px;
  `}
`
const Heading = styled.div`
  margin-bottom: 16px;
  text-align: left;
  h1 {
    font-size: 1.25em;
    display: inline;
    background-image: linear-gradient(transparent 66%, #73b7ff 34%);
    font-weight: ${fontWeight.bold} !important;
    margin-top: 0;
    margin-bottom: 0;
    letter-spacing: 1.25px;
  }
  ${media.md`
    margin-bottom: 32px;
    h1 {
      font-size: 2em;
    }
  `}
`

const Section = ({ heading, children, style, headingStyle }) => {
  return (
    <SectionStyled style={style} className='wow fadeIn'>
      <Heading>
        <h1 style={headingStyle}>{heading}</h1>
      </Heading>
      {children}
    </SectionStyled>
  )
}

export default Section
